import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_ecwallet_reload",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Reload Now", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_10 = { class: "row mb-5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_12 = { class: "col-xxl-8" }
const _hoisted_13 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_19 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", {
    class: "custom-control-label",
    for: "optionsRadios_add"
  }, "+")
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_21 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", {
    class: "custom-control-label",
    for: "optionsRadios_minus"
  }, "-")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_23 = { class: "row mb-5" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_25 = { class: "col-xxl-8" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "col-lg-6 col-form-label fw-bold fs-3 text-left" }, [
  /*#__PURE__*/_createVNode("b", null, "TOTAL: ")
], -1)
const _hoisted_27 = { class: "col-lg-6 col-form-label fw-bold fs-3 text-right" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_31 = { class: "col-xxl-8" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { class: "col-lg-6 col-form-label fw-bold fs-3 text-left" }, [
  /*#__PURE__*/_createVNode("b", null, "Philippine Peso: ")
], -1)
const _hoisted_33 = { class: "col-lg-6 col-form-label fw-bold fs-3 text-right" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_35 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_37 = { class: "col-xxl-8" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { class: "col-lg-6 col-form-label fw-bold fs-3 text-left" }, [
  /*#__PURE__*/_createVNode("b", null, "Philippine Peso: ")
], -1)
const _hoisted_39 = { class: "col-lg-6 col-form-label fw-bold fs-3 text-right" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_41 = { class: "row mb-5" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_43 = { class: "col-md-6 fv-row py-6 text-center" }
const _hoisted_44 = {
  key: 1,
  href: "#",
  class: "btn btn-sm btn-success",
  "data-bs-toggle": "modal"
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_47 = {
  key: 1,
  class: "col-xxl-12"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-12 fv-row py-1" }, [
    /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
      /*#__PURE__*/_createVNode("span", { class: "" }, "Please input the OTP sent to your mobile phone.")
    ])
  ])
], -1)
const _hoisted_49 = { class: "row mb-5" }
const _hoisted_50 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_51 = { class: "row mb-5" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_53 = { class: "col-md-6 fv-row py-6 text-center" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_55 = {
  key: 1,
  href: "#",
  class: "btn btn-sm btn-success",
  "data-bs-toggle": "modal"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.reset_ecwallet();})
            }, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.hasPendingECWalletOTP == false)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode("div", _hoisted_12, [
                        _createVNode("table", _hoisted_13, [
                          (_ctx.ccode != '27')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createVNode("tr", null, [
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.computeTotalAmount(100)))
                                    }, "100.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computeTotalAmount(500)))
                                    }, "500.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.computeTotalAmount(1000)))
                                    }, "1,000.00")
                                  ])
                                ]),
                                _createVNode("tr", null, [
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.computeTotalAmount(5000)))
                                    }, "5,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.computeTotalAmount(10000)))
                                    }, "10,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.computeTotalAmount(20000)))
                                    }, "20,000.00")
                                  ])
                                ]),
                                _createVNode("tr", null, [
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.computeTotalAmount(50000)))
                                    }, "50,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.computeTotalAmount(100000)))
                                    }, "100,000.00")
                                  ]),
                                  _hoisted_14
                                ])
                              ], 64))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createVNode("tr", null, [
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.computeTotalAmount(25000)))
                                    }, "25,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.computeTotalAmount(50000)))
                                    }, "50,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.computeTotalAmount(100000)))
                                    }, "100,000.00")
                                  ]),
                                  _hoisted_15
                                ]),
                                _createVNode("tr", null, [
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.computeTotalAmount(250000)))
                                    }, "250,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.computeTotalAmount(500000)))
                                    }, "500,000.00")
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      class: "badge badge-light-primary cursor_is_pointer",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.computeTotalAmount(1250000)))
                                    }, "1,250,000.00")
                                  ]),
                                  _hoisted_16
                                ])
                              ], 64)),
                          _createVNode("tr", null, [
                            _hoisted_17,
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                name: "optionsRadios",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.optionsRadios = $event)),
                                class: "custom-control-input",
                                id: "optionsRadios_add",
                                value: 1
                              }, null, 512), [
                                [_vModelRadio, _ctx.optionsRadios]
                              ]),
                              _hoisted_18,
                              _hoisted_19
                            ]),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                name: "optionsRadios",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.optionsRadios = $event)),
                                class: "custom-control-input",
                                id: "optionsRadios_minus",
                                value: 0
                              }, null, 512), [
                                [_vModelRadio, _ctx.optionsRadios]
                              ]),
                              _hoisted_20,
                              _hoisted_21,
                              _withDirectives(_createVNode("input", {
                                style: {"display":"none"},
                                type: "text",
                                class: "form-control m-r-30 mb-2 dashboardFontStyle",
                                id: "totalAmount2",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.totalAmount2 = $event)),
                                placeholder: "Enter Amount here"
                              }, null, 512), [
                                [_vModelText, _ctx.totalAmount2]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_22
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode("label", _hoisted_27, [
                          _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(_ctx.totalAmount)) + " " + _toDisplayString(_ctx.currency), 1)
                        ])
                      ]),
                      _hoisted_28
                    ]),
                    (_ctx.ccode == '29')
                      ? (_openBlock(), _createBlock("div", _hoisted_29, [
                          _hoisted_30,
                          _createVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createVNode("label", _hoisted_33, [
                              _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(_ctx.totalAmount / 0.35)), 1)
                            ])
                          ]),
                          _hoisted_34
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.ccode == '27')
                      ? (_openBlock(), _createBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createVNode("label", _hoisted_39, [
                              _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(_ctx.totalAmount / 50)), 1)
                            ])
                          ]),
                          _hoisted_40
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createVNode("div", _hoisted_43, [
                        (_ctx.isProcessingReload == false)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "#",
                              class: "btn btn-sm btn-success",
                              "data-bs-toggle": "modal",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.process_ecwalletReload();})
                            }, " Proceed "))
                          : _createCommentVNode("", true),
                        (_ctx.isProcessingReload == true)
                          ? (_openBlock(), _createBlock("a", _hoisted_44, " Processing... "))
                          : _createCommentVNode("", true),
                        _hoisted_45,
                        _createVNode("a", {
                          href: "#",
                          class: "btn btn-sm btn-danger",
                          "data-bs-toggle": "modal",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.cancel_ecwalletReload();})
                        }, " Cancel ")
                      ]),
                      _hoisted_46
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPendingECWalletOTP == true)
                ? (_openBlock(), _createBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode("div", _hoisted_49, [
                      _createVNode("div", _hoisted_50, [
                        _withDirectives(_createVNode("input", {
                          type: "number",
                          class: "form-control form-control-solid",
                          id: "ecwallet_otp",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.model_ecwallet_otp = $event)),
                          placeholder: "Enter OTP"
                        }, null, 512), [
                          [_vModelText, _ctx.model_ecwallet_otp]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createVNode("div", _hoisted_53, [
                        (_ctx.isProcessingOTP == false)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "#",
                              class: "btn btn-sm btn-success",
                              "data-bs-toggle": "modal",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.process_ecwalletOTP();})
                            }, " Proceed "))
                          : _createCommentVNode("", true),
                        _hoisted_54,
                        (_ctx.isProcessingOTP == true)
                          ? (_openBlock(), _createBlock("a", _hoisted_55, " Processing.. "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_56
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.loading]
      ])
    ])
  ], 64))
}